export const allLocationsId = 'all';
